import { useRest } from "../useRest";
import { buildKey } from "../utils/buildKey";
import { routeTo } from "../utils/routeTo";

const routes = {
  profile: () => routeTo("profile"),
};
const keys = {
  profile: () => buildKey("profile"),
};
const actions = {
  fetch: (options) =>
    useRest.fetch({
      url: routes.profile(),
      key: keys.profile(),
      options,
    }),
};
export const useProfile = {
  routes,
  keys,
  ...actions,
};
